document.addEventListener("DOMContentLoaded", function () {


    /* SLIDE UP */
    let slideUp = (target, duration = 500) => {

        target.style.transitionProperty = 'height, margin, padding';
        target.style.transitionDuration = duration + 'ms';
        const computed = getComputedStyle(target);
        if (computed.boxSizing === "border-box") {
            target.style.height = target.offsetHeight + 'px';
        } else {
            const pt = parseFloat(computed.paddingTop);
            const pb = parseFloat(computed.paddingBottom);
            const bt = parseFloat(computed.borderTopWidth);
            const bb = parseFloat(computed.borderBottomWidth);
            target.style.height = target.offsetHeight - pt - pb - bt - bb + 'px';
        }
        target.offsetHeight;
        target.style.overflow = 'hidden';
        target.style.height = 0;
        target.style.paddingTop = 0;
        target.style.paddingBottom = 0;
        target.style.marginTop = 0;
        target.style.marginBottom = 0;
        window.setTimeout(() => {
            target.style.display = 'none';
            target.style.removeProperty('height');
            target.style.removeProperty('padding-top');
            target.style.removeProperty('padding-bottom');
            target.style.removeProperty('margin-top');
            target.style.removeProperty('margin-bottom');
            target.style.removeProperty('overflow');
            target.style.removeProperty('transition-duration');
            target.style.removeProperty('transition-property');
            //alert("!");
        }, duration);
    }

    /* SLIDE DOWN */
    let slideDown = (target, duration = 500) => {

        target.style.removeProperty('display');
        let display = window.getComputedStyle(target).display;
        if (display === 'none') display = 'block';
        target.style.display = display;
        let height = target.offsetHeight;
        target.style.overflow = 'hidden';
        target.style.height = 0;
        target.style.paddingTop = 0;
        target.style.paddingBottom = 0;
        target.style.marginTop = 0;
        target.style.marginBottom = 0;
        target.offsetHeight;
        target.style.boxSizing = 'border-box';
        target.style.transitionProperty = "height, margin, padding";
        target.style.transitionDuration = duration + 'ms';
        target.style.height = height + 'px';
        target.style.removeProperty('padding-top');
        target.style.removeProperty('padding-bottom');
        target.style.removeProperty('margin-top');
        target.style.removeProperty('margin-bottom');
        window.setTimeout(() => {
            target.style.removeProperty('height');
            target.style.removeProperty('overflow');
            target.style.removeProperty('transition-duration');
            target.style.removeProperty('transition-property');
        }, duration);
    }



    // const accordeonElements = document.querySelectorAll('.accordeon_title');
    // accordeonElements.forEach((accordeonElement) => {
    //     accordeonElement.addEventListener('click', () => {
    //         const accordeonState = accordeonElement.getAttribute('data-accordeon');
    //         if (accordeonState == 'closed'){
    //             slideDown(accordeonElement.nextSibling)
    //         }else{
    //             slideUp(accordeonElement.nextSibling)
    //         }
    //         const newAccordeonState = accordeonState === 'open' ? 'closed' : 'open';
    //         accordeonElement.setAttribute('data-accordeon', newAccordeonState);
    //     });
    // });



    const accordeonElements = document.querySelectorAll('.wp-block-starter-accordeon');

    accordeonElements.forEach((accordeonElement) => {
        const accordeonTitle = accordeonElement.querySelector('.accordeon_title');

        accordeonElement.addEventListener('click', () => {
            const accordeonState = accordeonTitle.getAttribute('data-accordeon');

            if (accordeonState == 'closed') {
                slideDown(accordeonTitle.nextSibling);
            } else {
                slideUp(accordeonTitle.nextSibling);
            }

            const newAccordeonState = accordeonState === 'open' ? 'closed' : 'open';
            accordeonTitle.setAttribute('data-accordeon', newAccordeonState);
        });
    });
});